import { motion } from "framer-motion";

export const FadeIn = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ kicker, title, description }) => (
  <div className="mb-14 flex flex-col gap-6 lg:mb-20 lg:flex-row lg:items-end lg:justify-between">
    <FadeIn>
      <p className="mb-4 font-mono text-xs font-medium uppercase tracking-[0.25em] text-brand-red">
        {kicker}
      </p>
      <h2 className="max-w-2xl font-display text-3xl font-semibold leading-[1.05] tracking-tight text-white sm:text-4xl lg:text-5xl">
        {title}
      </h2>
    </FadeIn>
    {description && (
      <FadeIn delay={0.12}>
        <p className="max-w-md text-sm leading-relaxed text-slate-400 sm:text-base">
          {description}
        </p>
      </FadeIn>
    )}
  </div>
);

export default FadeIn;
